import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './HeaderMain.module.scss';
import logo from '../../assets/logo.png';
import globe from '../../assets/hospitalReservation/globe.png';
import { loginCheck, logout } from '../../auth/auth';

interface HeaderMainProps {
  selectedTab: string;
  onTabChange: Dispatch<SetStateAction<string>>;
}

const HeaderMain: React.FC<HeaderMainProps> = ({
  selectedTab,
  onTabChange,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isLanguageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  
  function handleLanguageChange(langCode: string) {
    i18n.changeLanguage(langCode);
    localStorage.setItem('selectedLanguage', langCode);
    setLanguageDropdownOpen(false);
  }

  useEffect(() => {
    if (location.pathname === '/my-reservation') {
      onTabChange('myReservation');
    } else if (location.pathname === '/treatment-list') {
      onTabChange('consultation');
    } else if (location.pathname === '/myPage') {
      onTabChange('myPage')
    }
  }, [location.pathname, onTabChange]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);
  
  function handleLogout() {
    logout();
    
    localStorage.removeItem("token");
    sessionStorage.clear();
    
    navigate("/login", { replace: true });
  }

  return (
    <header className={styles.header}>
      <img
        src={logo}
        alt={t('headerMain.logoAlt')}
        className={styles.logo}
        onClick={() => navigate('/')}
      />
      <nav>
        <button
          className={`${styles.tabButton} ${
            selectedTab === 'consultation' ? styles.active : ''
          }`}
          onClick={() => navigate('/treatment-list')}
        >
          {t('headerMain.tabs.consultation')}
        </button>
        <button
          className={`${styles.tabButton} ${
            selectedTab === 'myReservation' ? styles.active : ''
          }`}
          onClick={() => navigate('/my-reservation')}
        >
          {t('headerMain.tabs.myReservation')}
        </button>
        <button
          className={`${styles.tabButton} ${
            selectedTab === 'myPage' ? styles.active : ''
          }`}
          onClick={() => navigate('/myPage')}
        >
          {t('headerMain.tabs.myPage')}
        </button>
        <button
          className={`${styles.tabButton} ${
            selectedTab === 'logout' ? styles.active : ''
          }`}
          onClick={() => handleLogout()}
        >
          {t('headerMain.tabs.logout')}
        </button>
        <div className={styles.languageContainer}>
          <img
            src={globe}
            alt="Language Selector"
            className={styles.globeIcon}
            onClick={() => setLanguageDropdownOpen(!isLanguageDropdownOpen)}
          />
          {isLanguageDropdownOpen && (
            <ul className={styles.languageDropdown}>
              <li onClick={() => handleLanguageChange('en')}>English</li>
              <li onClick={() => handleLanguageChange('zh')}>中文</li>
              <li onClick={() => handleLanguageChange('ja')}>日本語</li>
              <li onClick={() => handleLanguageChange('ar')}>العربية</li>
            </ul>
          )}
        </div>
      </nav>
    </header>
  );
};

export default HeaderMain;
